import { gql } from "@apollo/client"

export const revokeKeeperDevices = gql`
  mutation revokeKeeperDevices($keeperId: String) {
    revokeKeeperDevices(keeperId: $keeperId)
  }
`
